export type {
	ConnectFragmentsState,
	ConnectAddonFragmentsFailure,
	ConnectAddonFragments,
	WebFragment,
} from './reducer';
export { default as connectFragmentsReducer, generateKey } from './reducer';
